
import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  PageTitle,
  ExampleWrapperSeamless,
} from '@/layout-components'
import {Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Tab,
  Tabs,
  TextField,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CssBaseline,
  ListItemButton,
  Menu, Box } from '@mui/material'
import withSession from '@/housefolios-components/Session/withSession'
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import MenuIcon from '@mui/icons-material/Menu'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import ClearIcon from '@mui/icons-material/Clear'
import clsx from 'clsx'
import AffiliateAdminTable from '@/housefolios-components/Affiliate/AffiliateAdminTable'
import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'
import {
  useQuery,
  useMutation,
  useApolloClient,
} from '@apollo/client/react'
import {
  UPDATE_AFFILIATE,
  ADD_AFFILIATE,
} from '@/housefolios-components/PartnerPortal/mutations'
import { DEFAULT_PREFERENCES } from '@/housefolios-components/OrganizationSettings/OrganizationPreferences'
import { ValidatorForm } from '@/housefolios-components/shared/muiFormValidator'
// Centralized lodash imports - much cleaner!
import {
  unset,
  map,
  merge,
  cloneDeep,
  get,
  set,
} from '@/utils/lodash'
import { useSnackbar } from 'notistack'
import axios from 'axios'
import { withUploadMember } from '@/utils/fileUpload'
import { GET_AFFILIATES } from '@/housefolios-components/CreateAccount/CreateAccountCard/queries'
import { GET_SIGNED_REQUEST } from '@/housefolios-components/PropertyContainer/queries'
import { UPDATE_USER_BY_EMAIL } from '@/housefolios-components/ReportsComponents/mutations'

const drawerWidth = 220

const listItems = [
  { name: 'General', icon: <SettingsTwoToneIcon /> },
  {
    name: 'Affiliate',
    icon: (
      <FontAwesomeIcon
        icon={['fas', 'gear']}
        style={{ fontSize: 24 }}
      />
    ),
  },
]

// Placeholder components for files, videos, articles, and admin table
const FileTable = () => (
  <Typography>File Table Placeholder</Typography>
)
const VideoTable = () => (
  <Typography>Video Table Placeholder</Typography>
)
const ArticleTable = () => (
  <Typography>Article Table Placeholder</Typography>
)
const AdminTable = () => (
  <Typography>Admin Table Placeholder</Typography>
)

// Mock affiliate data
const mockAffiliates = [
  {
    name: 'Paul McComas',
    hfpid: 'A1',
    companyName: 'Paul McComas',
    memberValue: 'paulmccomas',
    createdAt: 'Dec 15th 2021',
    status: 'active',
  },
  {
    name: 'John Helmick',
    hfpid: 'A2',
    companyName: 'Gorilla Capital',
    memberValue: 'gorillacapital',
    createdAt: 'Jan 24th 2022',
    status: 'active',
  },
  {
    name: 'Antonio Cucciniello',
    hfpid: 'A3',
    companyName: 'Investarters',
    memberValue: 'investarters',
    createdAt: 'Feb 3rd 2022',
    status: 'active',
  },
  {
    name: 'Carmen Fields',
    hfpid: 'A4',
    companyName: 'Think Realty',
    memberValue: 'thinkrealty',
    createdAt: 'Mar 21st 2022',
    status: 'active',
  },
  {
    name: 'Ramon Tookes',
    hfpid: 'A5',
    companyName: 'Flipology',
    memberValue: 'flipology',
    createdAt: 'Apr 8th 2022',
    status: 'active',
  },
  {
    name: 'Roger Blankenship',
    hfpid: 'A6',
    companyName: 'Flipping America',
    memberValue: 'flippingamerica',
    createdAt: 'Apr 8th 2022',
    status: 'active',
  },
  {
    name: 'Chris Naugle',
    hfpid: 'A7',
    companyName: 'Private Money Club',
    memberValue: 'privatemoneyclub',
    createdAt: 'Apr 8th 2022',
    status: 'active',
  },
  {
    name: 'Matthew Tortoriello',
    hfpid: 'A9',
    companyName: 'Two Guys Take on Real Estate',
    memberValue: 'twoguystakeonrealestate',
    createdAt: 'Apr 8th 2022',
    status: 'active',
  },
  {
    name: 'Jared Garfield',
    hfpid: 'A10',
    companyName: 'ROITK',
    memberValue: 'roitk',
    createdAt: 'Jul 12th 2022',
    status: 'active',
  },
  {
    name: 'Lori Greymont',
    hfpid: 'A11',
    companyName: 'Funding Faceoff',
    memberValue: 'fundingfaceoff',
    createdAt: 'Jul 21st 2022',
    status: 'active',
  },
  {
    name: 'Next Level',
    hfpid: 'A12',
    companyName: 'Veritas',
    memberValue: 'nextlevel',
    createdAt: 'Aug 17th 2022',
    status: 'active',
  },
  {
    name: 'Jason Henderson',
    hfpid: 'A13',
    companyName: 'Birmingham Insurance Group',
    memberValue: 'birmingham',
    createdAt: 'Dec 13th 2022',
    status: 'active',
  },
  {
    name: 'Sheldon Zimmerman',
    hfpid: 'A14',
    companyName: 'Home 365',
    memberValue: 'home365',
    createdAt: 'Feb 8th 2023',
    status: 'active',
  },
  {
    name: 'Jared Rossean',
    hfpid: 'A15',
    companyName: 'DBI Marketing with Housefolios Marketing',
    memberValue: 'dbi',
    createdAt: 'Mar 13th 2023',
    status: 'active',
  },
  {
    name: 'Marla Harmon',
    hfpid: 'A16',
    companyName: 'REI Social Media',
    memberValue: 'rei',
    createdAt: 'Apr 18th 2023',
    status: 'active',
  },
  {
    name: 'Arjan',
    hfpid: 'A17',
    companyName: 'Property Edge Pro',
    memberValue: 'pep',
    createdAt: 'May 31st 2023',
    status: 'active',
  },
  {
    name: 'Pace Morby',
    hfpid: 'pacemorby',
    companyName: 'Deal Sauce (Subto)',
    memberValue: 'pacemorby',
    createdAt: 'Apr 17th 2024',
    status: 'active',
  },
  {
    name: 'Jamil Damji',
    hfpid: 'astroflip',
    companyName: 'Deal Sauce (Astroflip)',
    memberValue: 'astroflip',
    createdAt: 'Apr 17th 2024',
    status: 'active',
  },
]

// Move affiliateSections definition here, after imports and before HouseFoliosAdminPage
const affiliateSections = [
  {
    label: 'Affiliate Info',
    fields: [
      {
        name: 'name',
        label: 'Name',
        type: 'text',
        validators: ['required'],
        errorMessages: ['This field is required'],
      },
      {
        name: 'hfpid',
        label: 'Affiliate ID',
        type: 'text',
        validators: ['required'],
        errorMessages: ['This field is required'],
      },
      {
        name: 'companyName',
        label: 'Company Name',
        type: 'text',
        validators: ['required'],
        errorMessages: ['This field is required'],
      },
      {
        name: 'email',
        label: 'Email',
        type: 'text',
        validators: ['required'],
        errorMessages: ['This field is required'],
      },
      {
        name: 'phone',
        label: 'Phone',
        type: 'text',
        validators: ['matchRegexp:^[0-9()-]+$'],
        errorMessages: ['Not a valid phone number'],
      },
      {
        name: 'commission',
        label: 'Commission %',
        type: 'number',
      },
      {
        name: 'memberValue',
        label: 'Affiliate Tag',
        type: 'text',
        validators: ['required'],
        errorMessages: ['This field is required'],
      },
      {
        name: 'orgId',
        label: 'Org Id',
        type: 'text',
        validators: ['required'],
        errorMessages: ['This field is required'],
      },
      // Default Strategy options will be set in the component
      {
        name: 'defaultStrategy',
        label: 'Default Strategy',
        type: 'select',
        options: [], // Will be set dynamically
        validators: ['required'],
        errorMessages: ['This field is required'],
      },
    ],
  },
  {
    label: 'Create Account',
    fields: [
      {
        name: 'createAccount.headerImage',
        label: 'Create Account Image',
        type: 'file',
      },
      {
        name: 'createAccount.memberTrial',
        label: 'Trial Days',
        type: 'number',
      },
    ],
  },
  {
    label: 'Sign In Page',
    fields: [
      {
        name: 'signIn.headerImage',
        label: 'Sign In Image',
        type: 'file',
      },
    ],
  },
  {
    label: 'Launchpad Page',
    fields: [
      {
        name: 'launchpad.memberLayout',
        label: 'Default Layout',
        type: 'select',
        options: [
          {
            value: true,
            label: 'Yes',
          },
          {
            value: false,
            label: 'No',
          },
        ],
      },
      {
        name: 'launchpad.memberWelcomeVideo',
        label: 'Welcome Video URL',
        type: 'text',
      },
    ],
  },
  {
    label: 'Left Nav',
    fields: [
      {
        name: 'sidebar.sidebarMemberFullImage',
        label: 'Upload Full Image',
        type: 'file',
      },
      {
        name: 'sidebar.sidebarMemberSmallImage',
        label: 'Upload Small Image',
        type: 'file',
      },
    ],
  },
  {
    label: 'Plan Details',
    fields: [
      {
        name: 'planDetails.price',
        label: 'Price',
        type: 'number',
        // validators: ['required'],
        errorMessages: ['This field is required'],
        // helperText: ...
      },
      {
        name: 'planDetails.paymentInterval',
        label: 'Payment Interval',
        type: 'select',
        options: [
          {
            value: 'monthly',
            label: 'Monthly',
          },
          {
            value: 'yearly',
            label: 'Yearly',
          },
        ],
        // validators: ['required'],
        errorMessages: ['This field is required'],
      },
      {
        name: 'planDetails.portfolioLimit',
        label: 'Portfolio Limit',
        type: 'number',
      },
      {
        name: 'planDetails.marketplaceLimit',
        label: 'Marketplace Limit',
        type: 'number',
      },
      {
        name: 'planDetails.teamLimit',
        label: 'Team Limit',
        type: 'number',
      },
      {
        name: 'planDetails.propertyCount',
        label: 'Property Count',
        type: 'number',
      },
    ],
  },
]

const HouseFoliosAdminPage = (props) => {
  const [activeTab, setActiveTab] = useState(0)
  const [showPage, setShowPage] = useState('file')
  const [openDialog, setOpenDialog] = useState(false)
  const [openAddAdmin, setOpenAddAdmin] = useState(false)
  const [addAdminLoading, setAddAdminLoading] = useState(false)
  const [openPreferences, setOpenPreferences] = useState(false)
  const [drawerOpen, setDrawerOpen] = useState(true)
  const [adminTab, setAdminTab] = useState('General')
  const [adminEmail, setAdminEmail] = useState('')
  // Add Affiliate dialog state for top-level button
  const [openAffiliateEdit, setOpenAffiliateEdit] = useState(false)
  const [affiliateInput, setAffiliateInput] = useState({})

  const { enqueueSnackbar } = useSnackbar()
  const [updateUserByEmail] = useMutation(UPDATE_USER_BY_EMAIL)

  const grantHousefoliosAdmin = async () => {
    const email = (adminEmail || '').trim()
    if (!email) {
      enqueueSnackbar('Enter an email address', { variant: 'error'  })
      return
    }
    setAddAdminLoading(true)
    try {
      await updateUserByEmail({
        variables: {
          email,
          userInput: { housefoliosAdmin: true },
        },
      })
      enqueueSnackbar(`Admin access granted to ${email}`, {
        variant: 'success',
        autoHideDuration: 3000,
      })
      setAdminEmail('')
      setOpenAddAdmin(false)
    } catch (error) {
      const message = String(error?.message || '')
        .replace(/^GraphQL error:\s*/i, '')
        .trim()
      enqueueSnackbar(message || 'Failed to add admin', {
        variant: 'error',
        autoHideDuration: 4000,
      })
    } finally {
      setAddAdminLoading(false)
    }
  }

  const handleApply = () => grantHousefoliosAdmin()
  const handleRecalculate = () => alert('Recalculate logic goes here')

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  const handleShowPageChange = (event) => {
    setShowPage(event.target.value)
  }

  // For dynamic Default Strategy options
  const strategies = merge(
    cloneDeep(DEFAULT_PREFERENCES),
    props.session.me.activeOrg.memberPreferences,
    props?.session?.me?.activeOrg?.preferences,
  ).general['strategies']
  // Set options for Default Strategy
  affiliateSections[0].fields.find(
    (f) => f.name === 'defaultStrategy',
  ).options = strategies.map((preference) => ({
    value: preference.value,
    label: preference.value,
  }))

  // Apollo mutations
  const [updateAffiliate] = useMutation(UPDATE_AFFILIATE)
  const [addAffiliate] = useMutation(ADD_AFFILIATE)

  const handleAddAffiliate = () => {
    setAffiliateInput({})
    setOpenAffiliateEdit(true)
  }

  return (
    <>
      <PageTitle
        titleHeading="HouseFolios Admin"
        titleDescription="Manage training options for your HouseFolios admins"
        icon={
          <FontAwesomeIcon
            style={{ fontSize: 30 }}
            icon={['far', 'building']}

            sx={{ color: '#368cff' }}
          />
        }
      >
        {activeTab === 0 && showPage === 'file' && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenDialog(true)}
          >
            Upload File
          </Button>
        )}
        {activeTab === 0 && showPage === 'article' && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenDialog(true)}
          >
            Add Article
          </Button>
        )}
        {activeTab === 1 && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setAdminEmail('')
              setOpenAddAdmin(true)
            }}
          >
            Add Admin
          </Button>
        )}
      </PageTitle>
      <ExampleWrapperSeamless style={{ marginBottom: 20 }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Launchpad" />
          <Tab label="Admin" />
        </Tabs>
        {/* Launchpad Tab */}
        {activeTab === 0 && (
          <Grid
            container
            direction="row"
            spacing={2}
            sx={{
              alignItems: 'center',
            }}
          >
            <Grid
              size={12}
              container
              direction="row"
              spacing={2}
              sx={{
                justifyContent: 'center',
              }}
            >
              <TextField
                name="showPage"
                value={showPage}
                onChange={handleShowPageChange}
                label={'Show Page'}
                variant="outlined"
                fullWidth
                margin="dense"
                select
                style={{ marginTop: 35 }}
              >
                <MenuItem key={'file'} value={'file'}>
                  Files
                </MenuItem>
                <MenuItem key={'video'} value={'video'}>
                  Video
                </MenuItem>
                <MenuItem key={'article'} value={'article'}>
                  Article
                </MenuItem>
              </TextField>
            </Grid>
            <Grid size={12} sx={{ display: 'flex' }}>
              {showPage === 'video' && <VideoTable />}
              {showPage === 'file' && <FileTable />}
              {showPage === 'article' && <ArticleTable />}
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                name="welcomeVideo"
                label={'Welcome Video Url'}
                variant="outlined"
                fullWidth
                margin="dense"
                type="text"
                // value and onChange can be added if needed
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                name="defaultStrategy"
                label={'Default Strategy'}
                variant="outlined"
                fullWidth
                margin="dense"
                select
                // value and onChange can be added if needed
              >
                <MenuItem value="Buy & Hold">Buy & Hold</MenuItem>
                <MenuItem value="Fix & Flip">Fix & Flip</MenuItem>
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setOpenPreferences(true)}
              >
                Open Preferences
              </Button>
            </Grid>
          </Grid>
        )}
        {/* Admin Tab */}
        {activeTab === 1 && (
          <Grid
            size={12}

            style={{ marginTop: 10 }}
            sx={{ display: 'flex' }}
          >
            <Grid
              container
              style={{ paddingLeft: 24, paddingRight: 24 }}
            >
              <Grid
                size={12}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 8,
                }}
              >
                <Typography
                  variant="h5"
                  style={{ paddingTop: 25, marginRight: 16 }}
                >
                  Affiliates
                </Typography>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: '#28b854',
                    color: 'white',
                    fontWeight: 600,
                    marginRight: 16,
                  }}
                  onClick={() => {
                    handleAddAffiliate()
                  }}
                >
                  + Add Affiliate
                </Button>
              </Grid>
              <Grid
                size={12}
                style={{ paddingTop: 0, paddingBottom: 16 }}
              >
                <Typography variant="subtitle1">
                  A list of actions for Housefolios Affiliates.
                </Typography>
              </Grid>
              <Grid size={12} style={{ marginBottom: 8 }}>
                <Typography variant="h6">
                  Housefolios Affiliates
                </Typography>
                <Typography variant="subtitle2">
                  Add/Edit/Remove Affiliates.
                </Typography>
              </Grid>
              <Grid size={12}>
                <AffiliateListTable
                  updateAffiliate={updateAffiliate}
                  addAffiliate={addAffiliate}
                  affiliateSections={affiliateSections}
                  session={props.session}
                  setAffiliateInput={setAffiliateInput}
                  setOpenAffiliateEdit={setOpenAffiliateEdit}
                  affiliateInput={affiliateInput}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        <Dialog
          open={openAddAdmin}
          onClose={() => !addAdminLoading && setOpenAddAdmin(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Add Housefolios Admin</DialogTitle>
          <DialogContent>
            <Typography sx={{ mb: 2 }}>
              Give an existing user access to Housefolios Admin tools.
            </Typography>
            <TextField
              name="email"
              variant="outlined"
              label="Email"
              type="email"
              value={adminEmail}
              onChange={(event) => setAdminEmail(event.target.value)}
              fullWidth
              autoFocus
              required
              disabled={addAdminLoading}
              sx={{ mt: 1 }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenAddAdmin(false)}
              disabled={addAdminLoading}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={grantHousefoliosAdmin}
              disabled={addAdminLoading}
            >
              {addAdminLoading ? 'Applying…' : 'Apply'}
            </Button>
          </DialogActions>
        </Dialog>
        {/* Launchpad file/article dialog still pending real upload UI */}
        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          fullWidth
        >
          <DialogTitle>Dialog Placeholder</DialogTitle>
          <DialogContent>
            <Typography>Dialog content goes here...</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* Preferences Dialog with Drawer and AppBar */}
        <Dialog
          open={openPreferences}
          onClose={() => setOpenPreferences(false)}
          maxWidth="md"
          fullWidth
          fullScreen
        >
          <div style={{ display: 'flex', height: 500 }}>
            <CssBaseline />
            {drawerOpen && (
              <Drawer
                variant="persistent"
                anchor="left"
                open={drawerOpen}
                sx={{
                  width: drawerWidth,
                  flexShrink: 0,
                  '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                  },
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px 8px',
                    justifyContent: 'flex-end',
                  }}
                >
                  <IconButton
                    onClick={() => setDrawerOpen(false)}
                    size="large"
                  >
                    <ChevronLeftIcon />
                  </IconButton>
                </div>
                <Divider />
                <List>
                  {listItems.map((section) => (
                    <ListItem key={section.name} disablePadding>
                      <ListItemButton
                        selected={adminTab === section.name}
                        onClick={() => setAdminTab(section.name)}
                      >
                        <ListItemIcon style={{ paddingLeft: 20 }}>
                          {section.icon}
                        </ListItemIcon>
                        <ListItemText primary={section.name} />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Drawer>
            )}
            <main
              style={{
                flexGrow: 1,
                // marginLeft: drawerOpen ? drawerWidth : 0,
                transition: 'margin-left 0.3s',
              }}
            >
              <AppBar
                position="static"
                color="primary"
                style={{ marginBottom: 24 }}
              >
                <Toolbar>
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={() => setDrawerOpen(true)}
                    edge="start"
                    style={{ color: 'white', marginRight: 16 }}
                    size="large"
                  >
                    <MenuIcon />
                  </IconButton>
                  <Typography
                    variant="h6"
                    style={{ color: 'white' }}
                    noWrap
                  >
                    Housefolios Admin
                  </Typography>
                  <div style={{ flex: 1 }} />
                  <Button
                    variant="outlined"
                    size="small"
                    style={{ color: 'white', borderColor: 'white' }}
                    onClick={() => setOpenPreferences(false)}
                  >
                    Close
                  </Button>
                </Toolbar>
              </AppBar>
              {adminTab === 'General' && (
                <Grid container>
                  <Grid size={12}>
                    <Typography
                      variant="h5"
                      style={{ paddingTop: 25 }}
                    >
                      General
                    </Typography>
                  </Grid>
                  <Grid
                    size={12}
                    style={{ paddingTop: 10, paddingBottom: 25 }}
                  >
                    <Typography variant="subtitle1">
                      A list of general actions for Housefolios.
                    </Typography>
                  </Grid>
                  <Grid size={12}>
                    <Typography variant="h6">
                      Housefolios Admin
                    </Typography>
                  </Grid>
                  <Grid size={12}>
                    <Typography variant="subtitle2">
                      Give a user access to Housefolios Admin tools.
                    </Typography>
                  </Grid>
                  <Grid
                    size={12}
                    container
                    spacing={1}
                    direction="row"
                    sx={{
                      alignItems: 'center',
                    }}
                  >
                    <Grid>
                      <TextField
                        name="email"
                        variant="outlined"
                        label="Email"
                        value={adminEmail}
                        onChange={(event) =>
                          setAdminEmail(event.target.value)
                        }
                        fullWidth
                        size="small"
                        style={{ minWidth: 200 }}
                      />
                    </Grid>
                    <Grid>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleApply}
                      >
                        Apply
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid size={12} style={{ paddingTop: 10 }}>
                    <Typography variant="h6">Reset Calcs</Typography>
                  </Grid>
                  <Grid size={12}>
                    <Typography variant="subtitle2">
                      This will recalculate ALL calculations. Don't do
                      this unless instructed to.
                    </Typography>
                  </Grid>
                  <Grid>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: '#f83145',
                        color: 'white',
                      }}
                      onClick={handleRecalculate}
                    >
                      Recalculate
                    </Button>
                  </Grid>
                </Grid>
              )}
              {adminTab === 'Affiliate' && (
                <Grid
                  container
                  style={{ paddingLeft: 24, paddingRight: 24 }}
                >
                  <Grid
                    size={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 8,
                    }}
                  >
                    <Typography
                      variant="h5"
                      style={{ paddingTop: 25, marginRight: 16 }}
                    >
                      Affiliates
                    </Typography>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: '#28b854',
                        color: 'white',
                        fontWeight: 600,
                        marginRight: 16,
                      }}
                      onClick={() => {
                        handleAddAffiliate()
                      }}
                    >
                      + Add Affiliate
                    </Button>
                  </Grid>
                  <Grid
                    size={12}
                    style={{ paddingTop: 0, paddingBottom: 16 }}
                  >
                    <Typography variant="subtitle1">
                      A list of actions for Housefolios Affiliates.
                    </Typography>
                  </Grid>
                  <Grid size={12} style={{ marginBottom: 8 }}>
                    <Typography variant="h6">
                      Housefolios Affiliates
                    </Typography>
                    <Typography variant="subtitle2">
                      Add/Edit/Remove Affiliates.
                    </Typography>
                  </Grid>
                  <Grid size={12}>
                    <AffiliateListTable
                      updateAffiliate={updateAffiliate}
                      addAffiliate={addAffiliate}
                      affiliateSections={affiliateSections}
                      session={props.session}
                      setAffiliateInput={setAffiliateInput}
                      setOpenAffiliateEdit={setOpenAffiliateEdit}
                      affiliateInput={affiliateInput}
                    />
                  </Grid>
                </Grid>
              )}
            </main>
          </div>
        </Dialog>
      </ExampleWrapperSeamless>
      <EditAffiliateDialog
        open={openAffiliateEdit}
        onClose={() => {
          setOpenAffiliateEdit(false)
        }}
        affiliateInput={affiliateInput}
        setAffiliateInput={setAffiliateInput}
        updateAffiliate={updateAffiliate}
        addAffiliate={addAffiliate}
        GET_AFFILIATES={GET_AFFILIATES}
        affiliateSections={affiliateSections}
        session={props.session}
      />
    </>
  )
}

function formatDateWithSuffix(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)
  const day = date.getDate()
  const month = date.toLocaleString('en-US', { month: 'short'  })
  const year = date.getFullYear()
  // Get day suffix
  const j = day % 10,
    k = day % 100
  let suffix = 'th'
  if (j === 1 && k !== 11) suffix = 'st'
  else if (j === 2 && k !== 12) suffix = 'nd'
  else if (j === 3 && k !== 13) suffix = 'rd'
  return `${month} ${day}${suffix} ${year}`
}

// Utility to remove root-level keys with a dot ('.') from the input object
function cleanAffiliateInput(input) {
  const cleaned = {}
  for (const key in input) {
    if (!key.includes('.')) {
      cleaned[key] = input[key]
    }
  }
  return cleaned
}

// Whitelist of allowed AffiliateInput fields (update as needed)
const ALLOWED_AFFILIATE_INPUT_FIELDS = [
  'name',
  'orgId',
  'hfpid',
  'memberValue',
  'defaultStrategy',
  'companyName',
  'email',
  'phone',
  'createdAt',
  'commission',
  'active',
  'rehabTiers',
  'defaultMarketType',
  'marketTypes',
  'createAccount',
  'signIn',
  'launchpad',
  'sidebar',
  'training',
  'planDetails',
]

function filterAffiliateInput(input) {
  // First create a deep clone to avoid mutating the original
  const cleaned = cloneDeep(input)

  // Remove fields that shouldn't be in the input
  delete cleaned.__typename
  delete cleaned._id
  delete cleaned.workflows

  // Then filter to only include allowed fields
  const result = {}
  for (const key of ALLOWED_AFFILIATE_INPUT_FIELDS) {
    if (cleaned[key] !== undefined) {
      result[key] = cleaned[key]
    }
  }

  return result
}

// Real S3 upload logic
async function uploadFile(file, affiliateId, session, apolloClient) {
  const {
    data: { getSignedRequest },
  } = await apolloClient.mutate({
    mutation: GET_SIGNED_REQUEST,
    variables: {
      fileInput: withUploadMember(
        {
          filename: file.name,
          filetype: file.type,
          collection: 'affiliateImages',
          documentId: affiliateId,
        },
        session,
      ),
    },
  })
  const { signedRequest, url } = getSignedRequest
  await axios.put(signedRequest, file, {
    headers: { 'Content-type': file.type },
  })
  return {
    filename: file.name,
    filesize: file.size,
    filetype: file.type,
    url,
    createdAt: new Date(),
    createdBy: `${session?.me?.profile?.firstname || ''} ${session?.me?.profile?.lastname || ''}`,
  }
}

// Recursively process input, upload File objects, and replace with metadata
async function processFilesInInput(
  input,
  affiliateId,
  session,
  apolloClient,
) {
  if (Array.isArray(input)) {
    return Promise.all(
      input.map((item) =>
        processFilesInInput(item, affiliateId, session, apolloClient),
      ),
    )
  } else if (
    input &&
    typeof input === 'object' &&
    !(input instanceof File)
  ) {
    const result = {}
    for (const key of Object.keys(input)) {
      if (input[key] instanceof File) {
        result[key] = [
          await uploadFile(
            input[key],
            affiliateId,
            session,
            apolloClient,
          ),
        ]
      } else if (
        Array.isArray(input[key]) &&
        input[key][0] instanceof File
      ) {
        result[key] = await Promise.all(
          input[key].map((f) =>
            uploadFile(f, affiliateId, session, apolloClient),
          ),
        )
      } else {
        result[key] = await processFilesInInput(
          input[key],
          affiliateId,
          session,
          apolloClient,
        )
      }
    }
    return result
  } else {
    return input
  }
}

// Utility to coerce all number fields (including nested) to numbers
const NUMBER_FIELDS = [
  'commission',
  'createAccount.memberTrial',
  'planDetails.price',
  'planDetails.portfolioLimit',
  'planDetails.marketplaceLimit',
  'planDetails.teamLimit',
  'planDetails.propertyCount',
]
function coerceNumberFieldsDeep(input, numberFieldNames) {
  const out = cloneDeep(input)
  numberFieldNames.forEach((field) => {
    const val = get(out, field)
    if (val !== undefined && val !== null && val !== '')
      set(out, field, Number(val))
  })
  return out
}

function EditAffiliateDialog({
  open,
  onClose,
  affiliateInput,
  setAffiliateInput,
  updateAffiliate,
  addAffiliate,
  GET_AFFILIATES,
  handleCloseAffiliateOptions = undefined,
  affiliateSections,
  session,
}) {
  const { enqueueSnackbar } = useSnackbar()
  const apolloClient = useApolloClient()

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <ValidatorForm
        onSubmit={async () => {
          // 1. Clean and filter input
          const cleanedAffiliateInput =
            filterAffiliateInput(affiliateInput)

          // 2. Upload files and replace File objects with metadata
          const processedInput = await processFilesInInput(
            cleanedAffiliateInput,
            affiliateInput._id,
            session,
            apolloClient,
          )

          const processedInputWithNumbers = coerceNumberFieldsDeep(
            processedInput,
            NUMBER_FIELDS,
          )

          if (affiliateInput._id) {
            updateAffiliate({
              variables: {
                affiliateId: affiliateInput._id,
                affiliateInput: processedInputWithNumbers,
              },
              refetchQueries: [
                {
                  query: GET_AFFILIATES,
                },
              ],
            })
              .then(() => {
                enqueueSnackbar(`Success! Affiliate updated`, {
                  variant: 'success',
                  autoHideDuration: 3000,
                })
                onClose()
                if (handleCloseAffiliateOptions)
                  handleCloseAffiliateOptions()
              })
              .catch((error) => {
                console.error('[DEBUG] Update error:', error)
                enqueueSnackbar(`Failed to update affiliate`, {
                  variant: 'error',
                  autoHideDuration: 3000,
                })
              })
          } else {
            addAffiliate({
              variables: {
                affiliateInput: {
                  ...processedInputWithNumbers,
                  active: true,
                },
              },
              refetchQueries: [
                {
                  query: GET_AFFILIATES,
                },
              ],
            })
              .then(() => {
                enqueueSnackbar(`Success! Affiliate added`, {
                  variant: 'success',
                  autoHideDuration: 3000,
                })
                onClose()
              })
              .catch((error) => {
                console.error('[DEBUG] Add error:', error)
                enqueueSnackbar(`Failed to add affiliate`, {
                  variant: 'error',
                  autoHideDuration: 3000,
                })
              })
          }
        }}
      >
        <DialogTitle>
          {affiliateInput._id ? 'Edit' : 'Add'} Affiliate
        </DialogTitle>
        <DialogContent>
          {affiliateSections.map((section, i) => {
            const isTwoCol = section.fields.length > 1
            return (
              <Grid
                container
                spacing={2}
                key={i}
                style={{ marginBottom: 32 }}
              >
                <Grid size={12} style={{ marginBottom: 8 }}>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: 600 }}
                  >
                    {section.label}
                  </Typography>
                </Grid>
                {section.fields.map((field, j) => {
                  // If last field and odd number, span full width
                  const isLastOdd =
                    isTwoCol &&
                    section.fields.length % 2 === 1 &&
                    j === section.fields.length - 1
                  return (
                    <Grid
                      size={{
                        xs: 12,
                        sm: isTwoCol && !isLastOdd ? 6 : 12,
                      }}
                      key={field.name}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {renderInput(
                        field,
                        affiliateInput,
                        setAffiliateInput,
                        session,
                      )}
                    </Grid>
                  )
                })}
              </Grid>
            )
          })}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
          <Button variant="contained" color="primary" type="submit">
            Save
          </Button>
        </DialogActions>
      </ValidatorForm>
    </Dialog>
  )
}

function renderInput(
  field,
  affiliateInput,
  setAffiliateInput,
  session,
) {
  const value = get(affiliateInput, field.name) ?? ''
  const handleChange = (e) => {
    const val =
      field.type === 'number'
        ? Number(e.target.value)
        : e.target.value
    setAffiliateInput((prev) => {
      const newInput = cloneDeep(prev)
      set(newInput, field.name, val)
      return newInput
    })
  }

  // File upload
  if (field.type === 'file') {
    // Support File object (new upload) or array of uploaded file objects (from backend)
    let fileName = ''
    let fileUrl = null
    let hasFile = false
    if (value && typeof value === 'object' && value instanceof File) {
      fileName = value.name
      fileUrl = URL.createObjectURL(value)
      hasFile = true
    } else if (
      Array.isArray(value) &&
      value.length > 0 &&
      (value[0].url || value[0].filename)
    ) {
      fileName = value[0].filename || value[0].url || 'File'
      fileUrl = value[0].url || null
      hasFile = true
    }
    return (
      <div
        key={field.name}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          width: '100%',
        }}
      >
        <Typography
          variant="body1"
          style={{
            fontWeight: 500,
            marginBottom: 8,
            color: '#37375B',
          }}
        >
          {field.label}
        </Typography>
        {!hasFile && (
          <Button
            variant="contained"
            component="label"
            style={{ marginRight: 8 }}
          >
            Upload File
            <input
              type="file"
              hidden
              onChange={(e) => {
                const file = e.target.files[0]

                setAffiliateInput((prev) => {
                  const newInput = cloneDeep(prev)
                  set(newInput, field.name, file)
                  return newInput
                })
              }}
            />
          </Button>
        )}
        {hasFile && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              variant="body2"
              style={{ marginLeft: 4, marginRight: 4 }}
            >
              {fileName}
            </Typography>
            <IconButton
              size="small"
              onClick={() => {
                if (fileUrl) window.open(fileUrl, '_blank')
              }}
              style={{ marginRight: 2 }}
            >
              <AttachFileIcon fontSize="small" />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => {
                setAffiliateInput((prev) => {
                  const newInput = cloneDeep(prev)
                  if (Array.isArray(value)) {
                    set(newInput, field.name, [])
                  } else {
                    set(newInput, field.name, null)
                  }
                  return newInput
                })
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </div>
        )}
      </div>
    )
  }

  // Select/dropdown
  if (field.type === 'select') {
    return (
      <TextField
        key={field.name}
        select
        label={field.label}
        value={value}
        onChange={handleChange}
        fullWidth
        margin="dense"
        variant="outlined"
        helperText={field.helperText}
        slotProps={{
          formHelperText: { style: { marginLeft: 0 } },
        }}
      >
        {field.options?.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>
    )
  }

  // Number/text
  return (
    <TextField
      key={field.name}
      name={field.name}
      label={field.label}
      value={value}
      onChange={handleChange}
      fullWidth
      margin="dense"
      variant="outlined"
      type={field.type === 'number' ? 'number' : 'text'}
      helperText={field.helperText}
      slotProps={{
        formHelperText: { style: { marginLeft: 0 } },
      }}
    />
  )
}

function AffiliateListTable(props) {
  const { loading, error, data } = useQuery(GET_AFFILIATES)
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedAffiliate, setSelectedAffiliate] = useState(null)
  const menuOpen = Boolean(anchorEl)

  // Use dialog state from parent
  const { setAffiliateInput, setOpenAffiliateEdit, affiliateInput } =
    props

  const { enqueueSnackbar } = useSnackbar()

  // TODO: Replace with actual implementations or pass as props
  const updateAffiliate =
    props.updateAffiliate || (() => Promise.resolve())
  const addAffiliate = props.addAffiliate || (() => Promise.resolve())
  const affiliateSections = props.affiliateSections || []
  const session = props.session || {}

  const handleMenuOpen = (event, affiliate) => {
    setAnchorEl(event.currentTarget)
    setSelectedAffiliate(affiliate)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
    setSelectedAffiliate(null)
  }
  const handleEditAffiliate = () => {
    setAffiliateInput(selectedAffiliate)
    setOpenAffiliateEdit(true)
    handleMenuClose()
  }

  if (loading) return <LoadingSkeleton variant="table" columnCount={7} />
  if (error) return <Typography>Error loading affiliates.</Typography>

  const affiliates = data?.affiliates || []

  // Debug log for affiliateInput state

  return (
    <>
      <Grid container>
        <Grid size={12}>
          <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <Box component="table" style={{ width: '100%', borderCollapse: 'collapse' }} sx={[{ whiteSpace: 'nowrap', mb: 0 }, {
              width: "100%",
              marginBottom: "1rem",
              fontSize: "1rem",
              "& th, & td": { padding: "0.75rem", borderTop: "1px solid #e4e5f0", verticalAlign: "middle" },
              "& thead th": {
                textTransform: "uppercase",
                background: "#f4f5fd",
                fontSize: "0.875rem",
                verticalAlign: "middle",
                borderBottom: "2px solid #e4e5f0",
              },
              "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87)" },
            }]}>
              <thead data-hf="soft-panel">
                <tr sx={{ textAlign: 'center' }}>
                  <th style={{ padding: '6px 8px', fontWeight: 600 }}>
                    Name
                  </th>
                  <th style={{ padding: '6px 8px', fontWeight: 600 }}>
                    Affiliate ID
                  </th>
                  <th style={{ padding: '6px 8px', fontWeight: 600 }}>
                    Company Name
                  </th>
                  <th style={{ padding: '6px 8px', fontWeight: 600 }}>
                    Affiliate Tag
                  </th>
                  <th style={{ padding: '6px 8px', fontWeight: 600 }}>
                    Date Created
                  </th>
                  <th style={{ padding: '6px 8px', fontWeight: 600 }}>
                    Status
                  </th>
                  <th style={{ padding: '6px 8px', fontWeight: 600 }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {affiliates.map((aff, idx) => (
                  <tr
                    key={aff._id || idx}
                    sx={{ textAlign: 'center' }}
                  >
                    <td style={{ padding: '6px 8px' }}>{aff.name}</td>
                    <td style={{ padding: '6px 8px' }}>
                      {aff.hfpid}
                    </td>
                    <td style={{ padding: '6px 8px' }}>
                      {aff.companyName}
                    </td>
                    <td style={{ padding: '6px 8px' }}>
                      {aff.memberValue}
                    </td>
                    <td style={{ padding: '6px 8px' }}>
                      {formatDateWithSuffix(aff.createdAt)}
                    </td>
                    <td style={{ padding: '6px 8px' }}>
                      {aff.active ? 'active' : 'inactive'}
                    </td>
                    <td style={{ padding: '6px 8px' }}>
                      <IconButton
                        size="small"
                        onClick={(e) => handleMenuOpen(e, aff)}
                      >
                        <MoreVertOutlinedIcon />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem onClick={handleEditAffiliate}>
                Edit Affiliate
              </MenuItem>
              <MenuItem
                onClick={() => {
                  // Clean and filter the input before sending
                  const cleanedInput =
                    filterAffiliateInput(selectedAffiliate)
                  const newActive = !get(selectedAffiliate, 'active')

                  updateAffiliate({
                    variables: {
                      affiliateId: get(selectedAffiliate, '_id'),
                      affiliateInput: {
                        ...cleanedInput,
                        active: newActive,
                      },
                    },
                    refetchQueries: [
                      {
                        query: GET_AFFILIATES,
                      },
                    ],
                  })
                    .then(() => {
                      enqueueSnackbar(
                        `Success! Affiliate ${newActive ? 'enabled' : 'disabled'}`,
                        {
                          variant: 'success',
                          autoHideDuration: 3000,
                        },
                      )
                    })
                    .catch((error) => {
                      console.error(
                        '[DEBUG] Toggle active error:',
                        error,
                      )
                      enqueueSnackbar(
                        `Failed to ${newActive ? 'enable' : 'disable'} affiliate`,
                        {
                          variant: 'error',
                          autoHideDuration: 3000,
                        },
                      )
                    })
                    .finally(() => {
                      setOpenAffiliateEdit(false)
                      handleMenuClose()
                    })
                }}
              >
                {get(selectedAffiliate, 'active')
                  ? 'Disable Affiliate'
                  : 'Enable Affiliate'}
              </MenuItem>
            </Menu>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default withSession(HouseFoliosAdminPage)
